module.exports = __webpack_public_path__ + "assets/img/DS-room2 (5).0290a49b.jpg";